const config = {
  // REQUIRED
  appName: "Animal Detect",
  // REQUIRED: a short description of your app for SEO tags (can be overwritten)
  appDescription:
    "Wildlife data processing platform for wildlife teams and researchers.",
  // REQUIRED (no https://, not trialing slash at the end, just the naked domain)
  domainName: "www.animaldetect.com",
  crisp: {
    // Crisp website ID. IF YOU DON'T USE CRISP: just remove this => Then add a support email in this config file (mailgun.supportEmail) otherwise customer support won't work.
    id: "7f689914-1cde-47b1-8413-4a0045ea3be5",
    // Hide Crisp by default, except on route "/". Crisp is toggled with <ButtonSupport/>. If you want to show Crisp on every routes, just remove this below
    onlyShowOnRoutes: ["/"],
  },
  resend: {
    // REQUIRED — Email 'From' field to be used when sending magic login links
    fromNoReply: `Animal Detect <noreply@animaldetect.com>`,
    // REQUIRED — Email 'From' field to be used when sending other emails, like abandoned carts, updates etc..
    fromAdmin: `Eugene from Animal Detect <eugene@animaldetect.com>`,
    // Email shown to customer if need support. Leave empty if not needed => if empty, set up Crisp above, otherwise you won't be able to offer customer support."
    supportEmail: "support@animaldetect.com",
    // When someone replies to supportEmail sent by the app, forward it to the email below (otherwise it's lost). If you set supportEmail to empty, this will be ignored.
    forwardRepliesTo: "eugene@animaldetect.com", // This field is not needed in Resend.
    // Delay in seconds before the user can resend the "Forgot Password" email
    delay: 60,
  },
  auth: {
    // REQUIRED — the path to log in users. It's use to protect private routes (like /dashboard). It's used in apiClient (/libs/api.js) upon 401 errors from our API
    loginUrl: "/signin",
    // REQUIRED — the path you want to redirect users after successfull login (i.e. /dashboard, /private). This is normally a private page for users to manage their accounts. It's used in apiClient (/libs/api.js) upon 401 errors from our API & in ButtonSignin.js
    callbackUrl: "/dashboard",
  },
  homepage: "https://www.animaldetect.com",
  toast: {
    duration: 5000, // Duration of the toast in milliseconds
  },
  gcp: {
    uploadBatchSizeMB: 50,
    uploadGenerateSignedUrlsBatchSize: 300, // how many signed GCP urls to generate per 1 server action on /upload page
    uploadImagesPerBatch: 50, // how many images to upload per batch on /upload page
    signedUrlExpiration: 72 * 60 * 60 * 1000, // 72 hours in milliseconds (global, for all signed urls)
    deleteFilesBatchSize: 200, // how many files to delete in 1 request to GCP
    maxAvatarSizeMB: 5 * 1024 * 1024, // max size of avatar in MB
  },
  imageThumbnailWidth: 256,
  imageFullSizeWidth: 800,
  imageCroppingWidth: 256,
  batchDiscoveryPollingInterval: 10000, // 10 seconds

  cache: {
    indexedDBName: 'animaldetect',
    avatarUrlCacheStoreName: 'avatarUrls',
    avatarUrlExpiration: 7 * 24 * 60 * 60 * 1000, // 7 days in milliseconds
    fileMapCacheStoreName: 'fileMap',
  }
}

export default config
